define('fetch-offline',[],function() {

    var fetchOffline = function(options) {
        options = options || {};

        var debugMode = options.debugMode,
            offlinePackage = options.offlinePackage;

        return new Promise(function(resolve) {
            var res = {
                lang: null,
                training: null,
                user: null
            };

            if (!offlinePackage) {
                if (debugMode) {
                    window.console.log('data-context: no offline content');
                }
                resolve(res);
                return;
            }

            require(['offlineData'], function(data) {
                if (debugMode) {
                    window.console.log('data-context: offline content loaded');
                    window.console.dir(data);
                }
                resolve(data);
            });

        });
    };

    return fetchOffline;
});

